module.exports = __webpack_public_path__ + "static/media/member_1.4223eb7e.jpg";